import { Grid } from "@mui/material";
import { Spinner } from "../../../Loading/Spinner";
import HeadersRolePermissions from "./HeadersRolePermissions";
import SingleRolePermissionsTable from "./SingleRolePermissionsTable";
import { useSuperAdminPermissions } from "../../../../context/SuperAdmin/PermissionContext";
import AddPermissionModal from "./AddPermissionModal";
import DeletePermissionsModal from "./DeletePermissionsModal";
import { useAuthContext } from "../../../../hooks/Auth";

const SingleRolePermissions = () => {
  const { isLoadingPermissions } = useSuperAdminPermissions();
  const { canAccess } = useAuthContext();

  const isNotProfessor = canAccess("delete:roleApps") && canAccess("create:roleApps");

  if (isLoadingPermissions) {
    return <Spinner msg="Cargando por favor espere..." />;
  }

  return (
    <Grid
      container
      spacing={2}
      sx={{
        display: "flex",
        flexDirection: "column",
        marginTop: 3,
        width: "100%",
        marginX: "auto",
        paddingX: 4,
      }}
    >
      {/* crear o eliminar permiso */}
      {isNotProfessor && (
        <Grid item>
          <HeadersRolePermissions />
        </Grid>
      )}

      {/* Tabla de permisos */}
      <Grid item>
        <SingleRolePermissionsTable />
      </Grid>

      {/* Modal para agregar ummiapps */}
      {canAccess("create:roleApps") && <Grid item>
        <AddPermissionModal />
      </Grid>}

      {/* Modal para confirmar eliminar ummiapps */}
      {canAccess("delete:roleApps") && <Grid item>
        <DeletePermissionsModal />
      </Grid>}
    </Grid>
  );
};

export default SingleRolePermissions;
